import React from 'react'
import Checkbox from '@vtex/styleguide/lib/Checkbox'

import {
  FilterAttribute,
  isFilterDefaultValue,
} from '@/checkout-instore-legacy/components/FilterSidebar/typings'

type CheckboxListProps = {
  attribute: FilterAttribute
  values: FilterAttribute['values']
  onChange: (key: string, value: any) => void
}

export const CheckboxList = ({
  attribute,
  values,
  onChange,
}: CheckboxListProps) => {
  return (
    <>
      {values.map((value, index) => {
        return isFilterDefaultValue(value) ? (
          <div
            key={`${value.key}-${index}`}
            className="filter-checkbox-container mt5 f6 pl3"
            data-attribute={attribute.key}
          >
            <Checkbox
              checked={value.active}
              id={value.key}
              label={`${value.label} ${value.count ? `(${value.count})` : ''}`}
              name={value.label}
              onChange={() => onChange(value.key, true)}
              value={value.key}
            />
          </div>
        ) : (
          <></>
        )
      })}
    </>
  )
}
